





























































import Vue from 'vue'
import { Component, Prop, Emit, Watch } from 'vue-property-decorator'

@Component
export default class AuditDialog extends Vue {
  @Prop(Boolean) readonly value!: boolean;
  @Prop(Boolean) readonly showAction!: boolean;

  model = false;

  newCaseInput = {
    name: '',
    gender: '',
    birthday: '',
    phone: '',
    memo: ''
  };

  mounted () {
    this.model = this.value
  }

  @Emit('input')
  closeDialog () {
    return false
  }

  @Emit('cancel')
  cancelDialog () {
    this.closeDialog()
  }

  @Watch('value')
  valueChanged () {
    this.model = this.value
  }

  @Emit('reject')
  rejectDialog () {
    // do nothing
  }

  @Emit('pass')
  passDialog () {
    // do nothing
  }
}
